module.exports = __webpack_public_path__ + "static/img/14.55ecca5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/zh/14.png
// module id = Nr/e
// module chunks = 0